<template>
  <view>
    <slot />
  </view>
</template>

<script lang="ts" setup>
import propsConfig from '@/uni_modules/thorui/tui-config/index.js'
uni.$tui = propsConfig
</script>
